export default "__VITE_ASSET__Q8ZS3Yo0__"